
const url = "https://prometajp.com/api/controller/api-controller/actionLogin";
// const url = "http://192.168.1.15/ecom/prometa/api/controller/api-controller/actionLogin";
//const url = "http://192.168.1.3/ecom/prometa/api/controller/api-controller/actionLogin";

export function userLogin(loginData){
    return new Promise(async (resolve, reject) => {
        try {
            const config = {
                "Content-type": "application/json",
            }

            // console.log(loginData); return;
            const response = await fetch(url, {
                method: "POST",
                headers: config,
                body: loginData,
            });

            if(response.status === 200){
                const data = await response.json();
                // alert(JSON.stringify(data));
                // alert(JSON.stringify(data));
                // console.log(data);
                window.location.replace(`https://prometajp.com/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
				// window.location.replace(`http://192.168.1.15/ecom/prometa/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
               //window.location.replace(`http://192.168.1.3/ecom/prometa/api/user/user.php?customer_id=${data.lastCallData.PRO_U_SESS}`);
                resolve(data);
            }
            else{
                const error = await response.text();
                alert("Invalid Credential!");
                return 0;
                // reject(error);
            }
        } catch (error) {
            reject(error);
        }
    });
}
